import React, { Component } from 'react';
import styled from 'styled-components';
import { Box, Flex, Image } from 'rebass';
import RequestSummary from './RequestSummary';
import { connect } from 'react-redux';
import { reduxForm, Field, change } from 'redux-form';
import submit from './../components/Payment/submit';
import Text from './common/Text';
import styledProps from 'styled-props';
import { colors, fonts, textSizes, fontWeights } from './../tailwind';

const Container = styled.div`
  width: 100%;
  background-color: #ebebeb;
  position: relative;
`;

const Input = styled.input`
  width: ${({ width }) => width}px;
  height: 48px;
  border-radius: 4px;
  background-color: ${colors.white};
  border: solid 1px ${colors.gray};
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  padding-left: 16px;
  &::placeholder {
    color: ${colors.primary};
    opacity: 0.5;
  }
`;
const TextArea = styled.textarea`
  width: 416px;
  height: 160px;
  margin-bottom: 48px;
  border-radius: 4px;
  background-color: ${colors.white};
  border: solid 1px ${colors.gray};
  resize: none;
  font-family: ${fonts.text};
  font-size: ${textSizes.base};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  padding: 14.4px 16px;
  &::placeholder {
    color: ${colors.primary};
    opacity: 0.5;
  }
`;
const NextButton = styled.button`
  width: 98px;
  height: 47px;
  border-radius: 2px;
  background-color: ${colors.secondary};
  font-family: ${fonts.title};
  font-size: ${textSizes.xl};
  font-weight: ${fontWeights.bold};
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: ${colors.grayDark};
  margin-left: 318px;
  margin-bottom: 48px;
`;

const SubmitRequestBtn = styled.button`
  width: 213px;
  height: 47px;
  border-radius: 2px;
  background-color: ${colors.secondary};
  font-family: ${fonts.title};
  font-size: ${textSizes.xl};
  font-weight: ${fontWeights.bold};
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: ${colors.grayDark};
  border: none;
  cursor: pointer;
`;

const ModalBackground = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ModalContainer = styled.div`
  width: 506px;
  height: 316px;
  background-color: ${colors.white};
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12),
    6px 12px 12px 0 rgba(0, 0, 0, 0.24);
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
`;
const HomeBtn = styled.button`
  width: 106px;
  height: 48px;
  border-radius: 2px;
  background-color: #36c1d6;
  font-family: 'Proxima Nova';
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  text-align: center;
  color: #414243;
  margin-top: 24px;
  border: none;
  cursor: pointer;
`;

const DarkOverlay = styled.div`
  width: 100%;
  height: 100vh;
  background: red;
  position: fixed;
  top: 0px;
  left: 0px;
`;

const StartOverBtn = styled.button`
  width: 213px;
  height: 47px;
  border-radius: 2px;
  background-color: ${colors.white};
  font-family: ${fonts.title};
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.2px;
  color: ${colors.grayDark};
  border: none;
  cursor: pointer;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12),
    6px 12px 12px 0 rgba(0, 0, 0, 0.24);
`;

const StartOverContainer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.secondary};
`;

const Triangle = styled.div`
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid white;
  position: absolute;
  top: 0px;
`;

class Request extends Component {
  state = { showModal: false, displayAddressInfo: true };

  handleNextClick = () => {
    console.log(this.props);
    const { change } = this.props;
    const {
      guestId,
      currency,
      listData,
      listId,
      id,
      guestData: {
        userData: { email },
      },
    } = this.props.data;
    this.setState({
      displayAddressInfo: false,
    });
    change('creditCard', '4242424242424242');
    change('cvv', '483');
    change('expDate', '10/22');
    change('guestId', guestId);
    change('currency', currency);
    change('title', listData.title);
    change('listId', listId);
    change('reservationId', id);
    change('guestEmail', email);
    window.scrollTo(0, 0);
  };

  submitRequest = () => {
    this.setState({ showModal: true });
  };

  render() {
    console.log('request this.props: ', this.props);
    let { basePrice, checkIn, checkOut, listData } = this.props.data;
    let { handleSubmit, change } = this.props;
    return (
      <Container>
        <Flex justifyContent="center" width="100%">
          {this.state.displayAddressInfo ? (
            <Box mt={73} width={448}>
              <Text
                _5xl
                hairline
                primary
                header
                noclip
                style={{ lineHeight: 'initial' }}
              >
                Let's enter your billing information.
              </Text>
              <Box mt={24} width={384}>
                <Text lg grayDark noclip style={{ lineHeight: 1.2 }}>
                  This must be the information linked to the payment method
                  you'd like to use.
                </Text>
              </Box>
              {/* <form id='PaymentForm' onSubmit={handleSubmit}> */}
              <Box mt={24} mb={8}>
                <Text xl bold grayDark noclip>
                  Name
                </Text>
              </Box>
              <Flex mb={24}>
                <Box mr={16}>
                  <Input
                    width={200}
                    placeholder="First name"
                    onChange={({ target }) => change('firstName', target.value)}
                  />
                </Box>
                <Box>
                  <Input
                    width={200}
                    placeholder="Last name"
                    onChange={({ target }) => change('lastName', target.value)}
                  />
                </Box>
              </Flex>
              <Box mt={24} mb={8}>
                <Text xl bold grayDark noclip>
                  Billing Address
                </Text>
              </Box>
              <Box mb={16}>
                <Input
                  width={416}
                  placeholder="Street Address"
                  onChange={({ target }) =>
                    change('streetAddress', target.value)
                  }
                />
              </Box>
              <Box mb={16}>
                <Input
                  width={416}
                  placeholder="Apt, Suite, etc. (optional)"
                  onChange={({ target }) => change('unitNumber', target.value)}
                />
              </Box>
              <Flex mb={16}>
                <Box mr={16}>
                  <Input
                    width={256}
                    placeholder="City"
                    onChange={({ target }) => change('city', target.value)}
                  />
                </Box>
                <Input
                  width={144}
                  placeholder="State"
                  onChange={({ target }) => change('state', target.value)}
                />
              </Flex>
              <Box mb={48}>
                <Input
                  width={256}
                  placeholder="Zipcode"
                  onChange={({ target }) => change('zipcode', target.value)}
                />
              </Box>
              <Box mb={8} width={416}>
                <Text lg grayDark noclip style={{ lineHeight: 1.2 }}>
                  Tell the lender a little bit about what you're renting this
                  item for. There is a good chance they can give you some great
                  pointers.
                </Text>
              </Box>
              <TextArea
                placeholder="Ex: I want to take my family to explore some new trails up in American Fork canyon. Any tips on where to go?"
                onChange={({ target }) =>
                  change('reasonForRental', target.value)
                }
              />
              <Box>
                <NextButton type="button" onClick={this.handleNextClick}>
                  NEXT
                </NextButton>
              </Box>
              {/* </form> */}
            </Box>
          ) : (
            <Box mt={73} width={448}>
              <Text
                _5xl
                hairline
                header
                primary
                noclip
                style={{ lineHeight: 1.2 }}
              >
                Now we just need your payment details.
              </Text>
              <Box mt={24} width={384}>
                <Text lg grayDark text noclip style={{ lineHeight: 1.2 }}>
                  Don't worry, you won't be charged until the rental is approved
                  by the lender.
                </Text>
              </Box>
              <form onSubmit={handleSubmit(submit)}>
                <Box mt={24} mb={8}>
                  <Text xl bold grayDark noclip>
                    Card Details
                  </Text>
                  <Text sm grayDark noclip>
                    * Information below is from a test credit card. No charge
                    will occur.
                  </Text>
                </Box>
                <Box mb={16}>
                  <Input
                    width={416}
                    placeholder="Card Number"
                    value="4242 4242 4242 4242"
                  />
                </Box>
                <Flex mb={25}>
                  <Box mr={16}>
                    <Input width={100} placeholder="MM/YY" value="10/22" />
                  </Box>
                  <Input width={100} placeholder="CVV" value="483" />
                </Flex>
                <SubmitRequestBtn onClick={this.submitRequest} type="submit">
                  SUBMIT REQUEST
                </SubmitRequestBtn>
              </form>
            </Box>
          )}
          <Box ml={48} mt={73} mb={55}>
            <RequestSummary
              basePrice={basePrice}
              checkIn={checkIn}
              checkOut={checkOut}
              listData={listData}
              change={change}
            />
          </Box>
        </Flex>
        {this.state.showModal ? (
          <ModalBackground>
            <ModalContainer>
              <Box mb={24} mt={40}>
                <Text _5xl hairline header primary noclip>
                  Thank You!
                </Text>
              </Box>
              <Box mb={24}>
                <Text lg grayDark t_title noclip>
                  Test credit card used. No charge occurred.
                </Text>
              </Box>
              <StartOverContainer>
                <Triangle />
                <StartOverBtn
                  onClick={() => {
                    window.location = window.origin;
                  }}
                >
                  BACK TO HOME
                </StartOverBtn>
              </StartOverContainer>
            </ModalContainer>
          </ModalBackground>
        ) : null}
      </Container>
    );
  }
}

function validate({
  cvv,
  expDate,
  creditCard,
  firstName,
  lastName,
  streetAddress,
  unitNumber,
  city,
  state,
  zipcode,
  reasonForRental,
}) {
  const errors = {};
  if (!firstName) errors.firstName = 'Required';
  if (!lastName) errors.lastName = 'Required';
  console.log(errors);
  return errors;
}

Request = reduxForm({
  form: 'PaymentForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(Request);

const mapState = () => {};

export default connect(
  mapState,
  { change },
)(Request);



// WEBPACK FOOTER //
// ./src/components_new/Request.js